module.exports = __webpack_public_path__ + "static/logo-0aa2851b4bdd76da9933b02e9949369a.png";